// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "calendar-pJbfq";
var _5 = "header-d1OfY";
var _6 = "title-3pUFQ";
var _7 = "title__text-184XY";
var _8 = "title__cities-18-lZ";
var _9 = "title__icon-3qy9h";
var _a = "title__icon_reverse-1a3qS";
var _b = "ffpInfo-2T350";
var _c = "content-3uBrc";
var _d = "tabs-Ut3k_";
var _e = "tabs__flexContainer-1dJ4V";
var _f = "legNumber-5603J";
var _10 = "diagram-34wrY";
var _11 = "tab-O1TJC";
var _12 = "tab_active-6q-ZK";
var _13 = "tab__idicator-QT0__";
var _14 = "priceGraph-2yemN";
var _15 = "priceGraph__modal-2PbWB";
var _16 = "top_wrapper__modal-3Hwam";
var _17 = "content__modal-33yO2";
var _18 = "calendar__wrapper-3FRnA";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "calendar", _5 as "header", _6 as "title", _7 as "title__text", _8 as "title__cities", _9 as "title__icon", _a as "title__icon_reverse", _b as "ffpInfo", _c as "content", _d as "tabs", _e as "tabs__flexContainer", _f as "legNumber", _10 as "diagram", _11 as "tab", _12 as "tab_active", _13 as "tab__idicator", _14 as "priceGraph", _15 as "priceGraph__modal", _16 as "top_wrapper__modal", _17 as "content__modal", _18 as "calendar__wrapper" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "calendar": _4, "header": _5, "title": _6, "title__text": _7, "title__cities": _8, "title__icon": _9, "title__icon_reverse": _a, "ffpInfo": _b, "content": _c, "tabs": _d, "tabs__flexContainer": _e, "legNumber": _f, "diagram": _10, "tab": _11, "tab_active": _12, "tab__idicator": _13, "priceGraph": _14, "priceGraph__modal": _15, "top_wrapper__modal": _16, "content__modal": _17, "calendar__wrapper": _18 }
